<i [ngClass]="classFont"></i>
